import { SubsetBox } from '.'
import { StyledSingleBox, StyledSingleBoxContainer } from '../styled'

export const SingleBox = ({ visible = true, title, children, ...args }) => {
  if (!visible) return null

  return (
    <StyledSingleBoxContainer>
      <StyledSingleBox id="single-box">
        <SubsetBox {...args} title={title}>
          {children}
        </SubsetBox>
      </StyledSingleBox>
    </StyledSingleBoxContainer>
  )
}
